import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const stats = [{
  value: '+400',
  label: 'nutricionistas confían'
}, {
  value: '6+6+6',
  label: 'Tomos, Bonos y Planillas'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'LP',
  quote: '"Organicé todo el consultorio en una tarde. Los tomos, las planillas y los recursos me dieron un sistema completo que nunca había tenido."',
  author: '— Laura P., Buenos Aires | Nutricionista en Consultorio Privado'
}, {
  initials: 'MC',
  quote: '"Las planillas de seguimiento me cambiaron la forma de trabajar. Ahora tomo decisiones clínicas en cada control y mis pacientes sienten que la consulta tiene otro nivel."',
  author: '— Martín C., Rosario | Nutricionista Clínico — Centro de Salud'
}, {
  initials: 'SV',
  quote: '"Antes armaba cada plan desde cero. Ahora tengo los tomos, las planillas y el recetario listo. Personalizo en minutos y cobro lo que realmente vale mi trabajo."',
  author: '— Sofía V., Córdoba | Nutricionista Independiente'
}];
export function SocialProof() {
  useTrackSection('social-proof', 'Social Proof Section');
  return <section id="social-proof" className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,250,252) 0%, rgb(240,253,244) 40%, rgb(240,253,244) 85%, rgb(248,250,252) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-295">
      <div className="mx-auto max-w-4xl" data-id="element-296">

        {/* Stats Grid */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-297">
          {stats.map(stat => <div key={stat.label} data-id="element-298">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-299">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-green-700" data-id="element-300">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-301">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white border border-green-600/20 rounded-lg p-3 shadow-sm" data-id="element-302">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center bg-green-700/10 text-xs font-black text-green-700 rounded-full" data-id="element-303">
                {t.initials}
              </div>
              <div data-id="element-304">
                <div className="mb-1 text-[10px] text-green-700" data-id="element-305">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-306">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-307">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>

      </div>
    </section>;
}